import React from "react";
import PropTypes from "prop-types";
import { Table, Typography, Tag, Skeleton } from "antd";
import styles from "../index.scss";

const { Text } = Typography;

const InfoTable = ({ title, loading, dataSource, columns, tag, scroll }) => {
  return (
    <div className={styles["info-table__container"]}>
      <div className={styles["info-table__header"]}>
        <Text className={styles["info-table__title"]}>{title}</Text>
        {tag && (
          <Tag color={tag.color} className={styles["info-table__tag"]}>
            {tag.text}
          </Tag>
        )}
      </div>

      {loading ? (
        <div className={styles["info-table__skeleton-container"]}>
          <Skeleton
            active
            paragraph={{
              rows: dataSource?.length || 2,
              width: "100%",
            }}
            title={false}
          />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered={false}
          size="small"
          className={styles["info-table__table"]}
          scroll={scroll}
        />
      )}
    </div>
  );
};

InfoTable.propTypes = {
  title: PropTypes.string.isRequired,
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      editable: PropTypes.bool,
      render: PropTypes.func,
    })
  ),
  loading: PropTypes.bool,
  tag: PropTypes.shape({
    color: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  columns: PropTypes.arrayOf(PropTypes.object),
  scroll: PropTypes.object,
};

export default InfoTable;
